import {
  OpenAPI,
  type ReconciliationSpecIdList,
} from '@festina/life-general-types/life'
import { GeneralLedgerReconciliationService_reconciliationServiceGetGetReconciliationSpecIds } from '@festina/life-general-types/life/hooks/GeneralLedgerReconciliationService_reconciliationServiceGetGetReconciliationSpecIds'
import { toOpenApiComponent } from '@festina-life/api'
import type { ConfigurableServer, Optional } from '@festina-life/core'
import { useSuspenseQuery } from '@tanstack/react-query'

import { sendRequest } from '../components/exportButtons/utils'

const path =
  GeneralLedgerReconciliationService_reconciliationServiceGetGetReconciliationSpecIds.path

export const useFetchReconciliationSpecIds = ({
  tenantId,
  component,
}: {
  tenantId: string
  component: Optional<ConfigurableServer>
}) => {
  const isEnabled = !!component
  const openAPI = isEnabled ? toOpenApiComponent(component) : OpenAPI // fallback to Life openAPI to avoid undefined, but the query won't run because of the queryKey condition

  return useSuspenseQuery<ReconciliationSpecIdList | null>({
    queryKey: isEnabled ? [openAPI.BASE, path, { tenantId }] : [],

    queryFn: async () => {
      if (!isEnabled) {
        return Promise.resolve(null)
      }

      const response = await sendRequest({
        openAPI,
        url: `${openAPI.BASE}${path}`,
        tenantId,
      })

      if (response.status === 404) {
        return null
      }
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`)
      }

      return response.json()
    },
  })
}
